module.exports = __webpack_public_path__ + "img/اداری-و-سازمانی.6024561b.jpg";